import { ucfirst } from '@/functions/strings';

/**
 * @param {string} input
 *
 * @returns {string}
 */
export const ucfirstFilter = (input) => {
    return ucfirst(input);
};
